"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketAccelerateConfigurationOutput = {
    type: "structure",
    required: [],
    members: {
        Status: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=GetBucketAccelerateConfigurationOutput.js.map